// extracted by mini-css-extract-plugin
export default {"pdf":"PDFViewer_pdf__JUxfc","back":"PDFViewer_back__JEJmb"};